import { faCalendar, faCheck, faComment, faEye, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-date-picker";
import UniInput, { FormControlElement } from "../components/UniInput/UniInput";
import { Button, Spinner } from "react-bootstrap";
import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import '../styles/Notifications.scss';
import UniEditor from "../components/UniEditor/UniEditor";
import { useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import { Notice, NoticePost, NoticePut, createNotice, getEmptyNotice, getNoticeById, updateNotice } from "../services/noticeService";
import UniModal from "../components/UniModal/UniModal";
import { useUserStore } from "../store/user";

type PreviewState = {
    body: string,
    title: string
};

const ManageNotifications = () => {
    const [isEdit, setIsEdit] = useState(false);
    const [model, setModel] = useState<Notice>();
    const [isValid, setIsValid] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showSuccessModel, setShowSuccessModel] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>(``);
    const [previewContent, setPreviewContent] = useState<PreviewState>();
    const [error, setError] = useState<string>(``);
    const { t } = useTranslation();
    const navigate = useNavigate();
    let { id } = useParams();
    const { loginData } = useUserStore();

    useEffect(() => {
        if (id) {
            setIsEdit(true);
            setLoading(true);
            const func = async () => {
                const response = await getNoticeById(id ?? ``)
                if ((response?.success ?? false)) {
                    const notice = response.data;
                    setModel({...notice});
                    console.log(model);
                };
                setLoading(false);
            }

            func();
        } else {
            setModel(getEmptyNotice())
        }
    }, []);

    useEffect(() => {
        setIsValid(modelIsValid());
    }, [model]);

    const modelIsValid = (): boolean => {
        if (!model?.initialDate || !model?.finalDate || !model?.titlePt ||
            !model?.titleEs || !model?.titleEn || !model?.bodyPt ||
            !model?.bodyEn || !model?.bodyEs) 
        {
            setIsValid(false);
            return false;
        }

        if (model?.finalDate < model?.initialDate) {
            setIsValid(false);
            return false;
        }

        setIsValid(true);
        return true;
    }

    const onChangeValues = (e: any, prop: string) => {
        let modelUpdated = model;
        if (!modelUpdated) return;

        switch (prop) {
            case `titlePT`:
                modelUpdated.titlePt = e?.target?.value;
                break;
            case `titleEN`:
                modelUpdated.titleEn = e?.target?.value;
                break;
            case `titleES`:
                modelUpdated.titleEs = e?.target?.value;
                break; 
            case `country`:
                modelUpdated.country = e?.target?.value;
                break;
            case `group`:
                modelUpdated.purchaseGroup = Number(e?.target?.value);
                break;
            case `enabled`:
                modelUpdated.enabled = e;
                break;
            case `editorPt`:
                modelUpdated.bodyPt = e;
                break;
            case `editorEn`:
                modelUpdated.bodyEn = e;
                break;
            case `editorEs`:
                modelUpdated.bodyEs = e;
                break;
            default:
                return;
        }

        setModel({...modelUpdated});
    }

    const saveNotification = () => {
        setLoading(true);
        
        if (!modelIsValid()) {
            setErrorMessage(`Por favor informe todos os campos obrigatórios indentificados com o *`);
            setLoading(false);
        }

        if (!isEdit) {
            const noticeInsert: NoticePost = {
                titlePt: model?.titlePt ?? ``,
                titleEs: model?.titleEs ?? ``,
                titleEn: model?.titleEn ?? ``,
                bodyPt: model?.bodyPt ?? ``,
                bodyEs: model?.bodyEs ?? ``,
                bodyEn: model?.bodyEn ?? ``,
                author: loginData.email,
                initialDate: model?.initialDate,
                finalDate: model?.finalDate,
                purchaseGroup: model?.purchaseGroup || 1,
                country: model?.country || `ALL`
            };
    
            createNotice(noticeInsert)
            .then(response => {
                if (!response.success) {
                    setError(response.error ?? '');
                }
                else {
                    setShowSuccessModel(true);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
        } else {
            const noticeUpdate: NoticePut = {
                id: model?.id ?? ``,
                titlePt: model?.titlePt ?? ``,
                titleEs: model?.titleEs ?? ``,
                titleEn: model?.titleEn ?? ``,
                bodyPt: model?.bodyPt ?? ``,
                bodyEs: model?.bodyEs ?? ``,
                bodyEn: model?.bodyEn ?? ``,
                author: model?.author,
                initialDate: model?.initialDate,
                finalDate: model?.finalDate,
                purchaseGroup: model?.purchaseGroup || 1,
                country: model?.country || `ALL`,
                enabled: model?.enabled ?? true
            };
    
            updateNotice(noticeUpdate, model?.id ?? ``)
            .then(response => {
                if (!response.success) {
                    setError(response.error ?? '');
                }
                else {
                    setShowSuccessModel(true);
                }
            })
            .catch(e => console.log(e))
            .finally(() => setLoading(false));
        }
    }

    return (
        <>
            <div className='notification-wrapper'>
                <div className='notification-header w-100'>
                    <div className='notification-header-i'>
                        <FontAwesomeIcon icon={faComment} color='#00FF3C' size='xl' />
                        <p className='w-100'>{isEdit ? `Editar` : `Novo`} Informativo</p>
                    </div>
                </div>
                <div className="p-5 w-100">
                    <div className='d-flex gap-4 mb-3 flex-wrap'>
                        <div className='date'>
                            <label>Data Inicial*</label>
                            <DatePicker
                                id='date-picker'
                                disabled={loading}
                                value={model?.initialDate}
                                openCalendarOnFocus={false}
                                clearIcon={null}
                                calendarIcon={<FontAwesomeIcon icon={faCalendar} style={{height: 14}}/>}
                                dayPlaceholder=''
                                monthPlaceholder=''
                                yearPlaceholder=''
                                onChange={(e: any) => {
                                    const date = new Date(e);
                                    if (date) {
                                        let modelUpdated = model;
                                        if (modelUpdated) {
                                            modelUpdated.initialDate = date;
                                            setModel({...modelUpdated});
                                        }
                                    }
                                }}
                                closeCalendar
                                minDetail='month'
                            />                        
                        </div>

                        <div className='date'>
                            <label>Data Final*</label>
                            <DatePicker
                                id='date-picker'
                                clearIcon={null}
                                disabled={loading}
                                value={model?.finalDate}
                                openCalendarOnFocus={false}
                                calendarIcon={<FontAwesomeIcon icon={faCalendar} style={{height: 14}}/>}
                                dayPlaceholder=''
                                monthPlaceholder=''
                                yearPlaceholder=''
                                onChange={(e: any) => {
                                    const date = new Date(e);
                                    if (date) {
                                        let modelUpdated = model;

                                        if (modelUpdated) {
                                            modelUpdated.finalDate = date;
                                            setModel({...modelUpdated});
                                        }
                                    }
                                }}
                                closeCalendar
                                minDetail='month'
                            />                        
                        </div>
                        
                        <div>
                            <UniInput
                                id='group'
                                placeholder={t('notification.labelGroup')}
                                label={t('notification.labelGroup')}
                                isSelect
                                value={model?.purchaseGroup.toString()}
                                disabled={loading}
                                onChange={(e) => onChangeValues(e, 'group')}
                            >
                                <option value={'1'} selected>TODOS</option>
                                <option value={'2'}>PVC</option>
                                <option value={'3'}>QUIMICOS</option>
                            </UniInput>
                        </div>

                        <div>
                            <UniInput
                                id='group-c'
                                placeholder={t('notification.labelContry')}
                                label={t('notification.labelContry')}
                                isSelect
                                disabled={loading}
                                value={model?.country}
                                onChange={(e) => onChangeValues(e, 'country')}
                            >
                                <option value={'ALL'} selected>TODOS</option>
                                <option value={'AR'}>ARGENTINA</option>
                                <option value={'BR'}>BRASIL</option>
                            </UniInput>
                        </div>
                        {
                            isEdit && (
                                <div className="d-flex gap-2 align-items-center">
                                    Ativo
                                    <Switch 
                                        onChange={(e) => { onChangeValues(e, 'enabled')}} 
                                        disabled={loading} 
                                        checked={model?.enabled ?? true}
                                        height={20} 
                                        width={40} 
                                    />
                                </div>
                            )
                        }
                    </div>
                    <div className="d-flex gap-3 mb-2 flex-wrap">
                        <div>
                            <UniInput
                                id='titlePT'
                                disabled={loading}
                                placeholder={t('notification.labelTitlePT')}
                                label={t('notification.labelTitlePT') + `*`}
                                type='text'
                                value={model?.titlePt}
                                onChangeInput={(e) => onChangeValues(e, 'titlePT')}
                            />

                            <div className='body-editor'>
                                <UniEditor 
                                    disabled={loading} 
                                    label="Informativo PT*" 
                                    showPreview
                                    onChange={(value, d, s, e) => onChangeValues(value, 'editorPt')}
                                    defaultValue={isEdit ? model?.bodyPt : undefined}
                                    value={model?.bodyPt ?? ``}
                                    previewCallback={() => setPreviewContent({body: model?.bodyPt ?? ``, title: model?.titlePt ?? ``})}
                                />
                            </div>
                        </div>
                        <div>
                            <UniInput
                                id='titleES'
                                disabled={loading}
                                placeholder={t('notification.labelTitleES')}
                                label={t('notification.labelTitleES') + `*`}
                                type='text'
                                value={model?.titleEs}
                                onChangeInput={(e) => onChangeValues(e, 'titleES')}
                            />

                            <div className='body-editor'>
                                <UniEditor 
                                    disabled={loading} 
                                    label="Informativo ES*" 
                                    showPreview
                                    onChange={(value, d, s, e) =>  onChangeValues(value, 'editorEs')}
                                    defaultValue={isEdit ? model?.bodyEs : undefined}
                                    value={model?.bodyEs ?? ``}
                                    previewCallback={() => setPreviewContent({body: model?.bodyEs ?? ``, title: model?.titleEs ?? ``})}
                                />
                            </div>
                        </div>
                        <div>
                            <UniInput
                                id='titleEN'
                                disabled={loading}
                                placeholder={t('notification.labelTitleEN')}
                                label={t('notification.labelTitleEN') + `*`}
                                type='text'
                                value={model?.titleEn}
                                onChangeInput={(e) => onChangeValues(e, 'titleEN')}
                            />

                            <div className='body-editor'>
                                <UniEditor 
                                    disabled={loading} 
                                    label="Informativo EN*" 
                                    showPreview
                                    onChange={(value, d, s, e) =>  onChangeValues(value, 'editorEn')}
                                    defaultValue={isEdit ? model?.bodyEn ?? `` : undefined}
                                    value={model?.bodyEn ?? ``}
                                    previewCallback={() => setPreviewContent({body: model?.bodyEn ?? ``, title: model?.titleEn ?? ``})}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='d-flex justify-content-end gap-3'>
                        {
                            errorMessage && (<b>{errorMessage}</b>)
                        }
                        <Button variant='secondary' onClick={() => navigate('/notifications')}>
                            {t('notification.labelBack')}
                        </Button>
                        <Button variant='primary' disabled={!isValid} onClick={loading ? () => {} : () => saveNotification()}>
                            {loading ? <Spinner color="#fff"/> : t('notification.labelSave')}
                        </Button>
                    </div>
                </div>
            </div>

            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={error || `Ocorreu um erro ao salvar os dados`}
                onHide={() => {setError('')}}
                show={error !== ''}
                isFontAwsome
            />

            <UniModal 
                icon={faCheck}
                isFontAwsome
                iconColor='#00FF3C'
                title={`Sucesso`}
                message='Informativos salvos com sucesso'
                show={showSuccessModel}
                onHide={() => {
                    setShowSuccessModel(false);
                    navigate('/notification');
                }}
                iconWidth={100}
                iconHeight={100}
            >
                <div>
                    <Button 
                        className="mt-3"
                        onClick={() => {
                            setShowSuccessModel(false);
                            navigate('/notifications');
                        }
                    }>
                        OK
                    </Button>
                </div>
            </UniModal>

            <UniModal
                icon={undefined}
                message=''
                isHtmlContent
                title={previewContent?.title ?? ''}
                onHide={() => {setPreviewContent(undefined)}}
                show={previewContent != undefined}
            >
                <div dangerouslySetInnerHTML={{__html: previewContent?.body ?? ``}}/>
            </UniModal>
        </>
    )
}

export default ManageNotifications;